<div class="service-tree-wrapper common-style" [class.is-readonly]="readonly">
  <span class="title-name">{{ title }} @if (required) {
    <span class="mandatory-star">*</span>
  }</span>
  @if (showEmptyState && (!treeData || treeData.length === 0)) {
    <div class="service-tree-empty">
      <div class="service-tree-empty-text">No Services available.</div>
    </div>
  } @else {
    <div class="service-tree-controls">
      <div class="p-relative service-tree-search-wrap">
        <input
          type="text"
          class="form-control greybox service-tree-search-input"
          [value]="searchQuery"
          placeholder="Search services..."
          (input)="onSearchInput($event)" />
        @if (!hasActiveSearch) {
          <mat-icon class="icon-search" aria-hidden="true">search</mat-icon>
        } @else {
          <mat-icon class="icon-clear-filter" role="button" tabindex="0" aria-label="Clear search"
            (click)="clearSearch()" (keydown.enter)="clearSearch()" (keydown.space)="clearSearch()">close</mat-icon>
        }
      </div>
      <button
        type="button"
        class="btn-color filter-btn service-tree-select-all-btn"
        [disabled]="isSelectAllActionDisabled"
        [ngClass]="{'btn-active': isSelectAllActionActive}"
        (click)="toggleSelectAllServices()">
        {{ selectAllActionLabel }}
      </button>
    </div>

    @if (hasActiveSearch && !hasSearchResults) {
      <div class="service-tree-empty service-tree-search-empty">
        <div class="service-tree-empty-text">No matching services found.</div>
      </div>
    } @else {
    <div class="service-tree-container">
      <mat-tree [dataSource]="visibleNodes" [levelAccessor]="levelAccessor">

        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="20"
          [class.root-leaf]="node.level === 0">

          @if (node.level > 0) {
            <button type="button" mat-icon-button disabled class="hidden-spacer"></button>
          }
          @if (node.level === 0 && hasTopLevelGroups) {
            <div class="root-spacer"></div>
          }

          <mat-checkbox class="checklist-leaf-node" color="primary"
            [checked]="checklistSelection.isSelected(node)" [disabled]="readonly"
            (change)="todoLeafItemSelectionToggle(node)"
            (keydown.enter)="onLeafCheckboxEnter($event, node)">
            {{node.name}}
          </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
          <button type="button" mat-icon-button class="service-group-toggle" (click)="toggleNode(node)" [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <mat-checkbox [checked]="checklistSelection.isSelected(node)" color="primary" [disabled]="readonly"
            [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node)"
            (keydown.enter)="onParentCheckboxEnter($event, node)">
            <span class="fw-bold node-label">{{node.name}}</span>
            <span class="ms-1">{{getSelectionStatus(node)}}</span>
          </mat-checkbox>
        </mat-tree-node>

      </mat-tree>
    </div>
    }
  }
  @if (isEmpty() && showValidationError && (!showEmptyState || (treeData?.length || 0) > 0)) {
    <div
      class="mat-mdc-form-field-error mat-mdc-form-field-bottom-align mt-2"
      role="alert">
      Please select at least one affected service
    </div>
  }
</div>
